module.exports = __webpack_public_path__ + "img/logo-comiru.e2e961a.png";